import Vue from 'vue'

const actions = {

  /**
   * @param context
   */
  async getData (context) {
    const path = 'network?populate=Client'
    let result = await Vue.axios.get(path)
      .then(response => {
        for (let index = 0; index < response.data.length; index++) {
          addNetworkIdsField(response.data[index])
        }
        context.commit('SET_NETWORKLIST', response.data)
        return response.data
      })
    return result
  },

  setClient (context, clientSelected) {
    context.commit('SET_CURRENTCLIENT', clientSelected)
  },

  addNetwork (context, network) {
    context.commit('ADD_NETWORK', network)
  },
  async addAdminNetwork (context, networkId) {
    let network = await Vue.axios.get(`network/${networkId}`)
      .then(response => {
        return response.data
      })
    context.commit('User/ADD_ADMIN_NETWORK', network, { root: true })
  },
  /**
   * @param context
   */
  async getNetworks (context) {
    let networkList = await Vue.axios.get('network')
      .then(response => {
        return JSON.parse(JSON.stringify(response.data))
      })
    return networkList
  },
  async getConversionProfiles (context) {
    let profiles = await Vue.axios.get(`network/getConversionProfiles`)
      .then(response => {
        return response.data
      })
    return profiles
  },
  async getNetworkData (context, params) {
    let path = 'network/' + params.data.networkId
    let requestParam

    if (params.options && params.options.populate) {
      requestParam = { params: { populate: params.options.populate.join(',') } }
    }

    let network = await Vue.axios.get(path, requestParam)
      .then(response => {
        context.commit('UPDATE_NETWORK_IN_NETWORKLIST', response.data)
        return JSON.parse(JSON.stringify(response.data))
      })
    return network
  },

  async createNetworkData (context, params) {
    let response
    params.data.Client = params.data.ClientId

    delete params.data.id
    await Vue.axios.post('network', params.data)
      .then(response => {
        addNetworkIdsField(response.data)

        context.commit('ADD_NETWORK_TO_NETWORKLIST', response.data)
        response = response.data
      })

    return response
  },

  async updateNetworkData (context, params) {
    let response
    params.data.Client = params.data.ClientId
    if (!params.data.validTo) params.data.validTo = ''
    await Vue.axios.patch('network/' + params.data.id, params.data)
      .then(async response => {
        await context.dispatch('getNetworkData', {
          data: {
            networkId: params.data.id
          },
          options: {
            populate: ['Client']
          }
        })
        addNetworkIdsField(response.data)
        response = response.data
      })

    return response
  }
}

let addNetworkIdsField = function (networkData) {
  networkData.ClientId = networkData.Client !== null ? networkData.Client.id : null
  // networkData.DeviceIds = networkData.Devices.map(item => item.id)
  return networkData
}

export default actions



//////////////////
// WEBPACK FOOTER
// ./state/network/network.actions.js
// module id = null
// module chunks = 